module.exports = __webpack_public_path__ + "img/B2C_Teaser_1024x500_OffertaPrepagata_2019.10.18.8933b228.jpg";